/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './treatment-adverse-event.reducer';

export const TreatmentAdverseEvent = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const treatmentAdverseEventList = useAppSelector(state => state.treatmentAdverseEvent.entities);
  const loading = useAppSelector(state => state.treatmentAdverseEvent.loading);
  const totalItems = useAppSelector(state => state.treatmentAdverseEvent.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="treatment-adverse-event-heading" data-cy="TreatmentAdverseEventHeading">
        <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.home.title">Treatment Adverse Events</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/treatment-adverse-event/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.home.createLabel">Create new Treatment Adverse Event</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.treatmentAdverseEvent.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {treatmentAdverseEventList && treatmentAdverseEventList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('eventDate')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventDate">Event Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventDate')} />
                </th>
                <th className="hand" onClick={sort('eventDescription')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventDescription">Event Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventDescription')} />
                </th>
                <th className="hand" onClick={sort('severity')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.severity">Severity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('severity')} />
                </th>
                <th className="hand" onClick={sort('impactedParameters')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.impactedParameters">Impacted Parameters</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('impactedParameters')} />
                </th>
                <th className="hand" onClick={sort('mitigationStrategiesTaken')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.mitigationStrategiesTaken">
                    Mitigation Strategies Taken
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mitigationStrategiesTaken')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.plan">Plan</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.cycles">Cycles</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventType">Event Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.eventResult">Event Result</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.regimen">Regimen</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {treatmentAdverseEventList.map((treatmentAdverseEvent, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/treatment-adverse-event/${treatmentAdverseEvent.id}`} color="link" size="sm">
                      {treatmentAdverseEvent.id}
                    </Button>
                  </td>
                  <td>{treatmentAdverseEvent.eventDate}</td>
                  <td>{treatmentAdverseEvent.eventDescription}</td>
                  <td>{treatmentAdverseEvent.severity}</td>
                  <td>{treatmentAdverseEvent.impactedParameters}</td>
                  <td>{treatmentAdverseEvent.mitigationStrategiesTaken}</td>
                  <td>{treatmentAdverseEvent.active ? 'true' : 'false'}</td>
                  <td>{treatmentAdverseEvent.cursor}</td>
                  <td>{treatmentAdverseEvent.lastUpdated}</td>
                  <td>{treatmentAdverseEvent.microSec}</td>
                  <td>{treatmentAdverseEvent.timestampEntry}</td>
                  <td>
                    {treatmentAdverseEvent.plan ? (
                      <Link to={`/treatment-delivery-plan/${treatmentAdverseEvent.plan.id}`}>{treatmentAdverseEvent.plan.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {treatmentAdverseEvent.cycles ? (
                      <Link to={`/treatment-cycle/${treatmentAdverseEvent.cycles.id}`}>{treatmentAdverseEvent.cycles.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {treatmentAdverseEvent.eventType ? (
                      <Link to={`/clinical-dictionary/${treatmentAdverseEvent.eventType.id}`}>{treatmentAdverseEvent.eventType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {treatmentAdverseEvent.eventResult ? (
                      <Link to={`/clinical-dictionary/${treatmentAdverseEvent.eventResult.id}`}>
                        {treatmentAdverseEvent.eventResult.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {treatmentAdverseEvent.regimen ? (
                      <Link to={`/treatment-regimen/${treatmentAdverseEvent.regimen.id}`}>{treatmentAdverseEvent.regimen.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/treatment-adverse-event/${treatmentAdverseEvent.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/treatment-adverse-event/${treatmentAdverseEvent.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/treatment-adverse-event/${treatmentAdverseEvent.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.treatmentAdverseEvent.home.notFound">No Treatment Adverse Events found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={treatmentAdverseEventList && treatmentAdverseEventList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TreatmentAdverseEvent;
